import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const commerceCloudApiKind = createEnum(["admin", "shopper"] as const);
export type CommerceCloudApiKind = z.infer<typeof commerceCloudApiKind>;

/** Credentials are never returned whole — only the last 4 characters. */
const maskedCredentialsSchema = z.object({
  clientIdLast4: z.string(),
  clientSecretLast4: z.string(),
  scopes: z.array(z.string()),
});

export const getCommerceCloudSetup = {
  name: "getCommerceCloudSetup" as const,
  input: z.null(),
  output: z.union([
    z.object({ connected: z.literal(false) }),
    z.object({
      connected: z.literal(true),
      organizationId: z.string(),
      shortCode: z.string(),
      siteId: z.string(),
      instanceId: z.string(),
      realmId: z.string(),
      adminApi: maskedCredentialsSchema,
      shopperApi: maskedCredentialsSchema.nullable(),
      cartProductId: z.string().nullable(),
      storeUrl: z.string().nullable(),
    }),
  ]),
};

export type CommerceCloudSetup = z.infer<typeof getCommerceCloudSetup.output>;
